"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.AriaTelemetryProvider = void 0;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/map"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _webjsSdk = require("@aria/webjs-sdk");

var _environment = require("../environment");

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var _scrubTelemetryData = require("./scrubTelemetryData");

// If cookies are disabled for Aria (via process.env.APP_DISABLE_TELEMETRY_COOKIES), the following Map
// singleton will be used to store session data (e.g. session id, etc.).
// Note that this doesn't persist data between sessions, though this is okay for now, since Aria doesn't
// store any inter-session info that we care about.
var propertyStorageOverrideMap;

var AriaTelemetryProvider = /*#__PURE__*/function () {
  function AriaTelemetryProvider() {
    (0, _classCallCheck2.default)(this, AriaTelemetryProvider);
    this._logger = void 0;

    this._flushCallback = function () {
      return undefined;
    };
  }

  (0, _createClass2.default)(AriaTelemetryProvider, [{
    key: "initialize",
    value: function initialize() {
      if (process.env.APP_ENABLE_TELEMETRY === 'true') {
        var env = (0, _environment.determineEnvironment)(window.location);
        var telemetryKeyOverride = (0, _overrideSettings.getOverrideSetting)('ariaTelemetryKey');
        var telemetryKey = (0, _environment.getEnvironmentSetting)(env, '', process.env.APP_TELEMETRY_KEY, process.env.APP_TELEMETRY_KEY_PPE, process.env.APP_TELEMETRY_KEY_TIP, process.env.APP_TELEMETRY_KEY_LOCALHOST, process.env.APP_TELEMETRY_KEY_AR, process.env.APP_TELEMETRY_KEY_USSEC, process.env.APP_TELEMETRY_KEY_USNAT, telemetryKeyOverride);

        if (telemetryKey) {
          var configuration = undefined;

          if (process.env.APP_DISABLE_TELEMETRY_COOKIES === 'true') {
            propertyStorageOverrideMap = propertyStorageOverrideMap || new _map.default();
            configuration = {
              disableCookiesUsage: true,
              propertyStorageOverride: {
                setProperty: function setProperty(key, value) {
                  propertyStorageOverrideMap.set(key, value);
                },
                getProperty: function getProperty(key) {
                  return propertyStorageOverrideMap.get(key) || '';
                }
              }
            };
          }

          this._logger = _webjsSdk.AWTLogManager.initialize(telemetryKey, configuration);

          _webjsSdk.AWTLogManager.addNotificationListener({
            eventsDropped: function eventsDropped(events, reason) {
              console.error('Number of Events Dropped:', events.length, reason);
            }
          });
        }
      }
    }
  }, {
    key: "getSessionId",
    value: function getSessionId() {
      return this._logger && this._logger.getSessionId();
    }
  }, {
    key: "setSessionId",
    value: function setSessionId(_sessionId) {// Aria does not support setting the session id
    }
  }, {
    key: "logSession",
    value: function logSession(state, eventData) {
      if (this._logger !== undefined) {
        this._logger.logSession(state, eventData);
      }
    }
  }, {
    key: "logPageView",
    value: function logPageView(id, pageName, category, uri, referrerUri, properties) {
      if (this._logger !== undefined) {
        this._logger.logPageView(id, pageName, category, uri, referrerUri, properties);
      }
    }
  }, {
    key: "logEvent",
    value: function logEvent(eventData) {
      if (this._logger !== undefined) {
        this._logger.logEvent(eventData);
      }
    }
  }, {
    key: "logFailure",
    value: function logFailure(signature, detail, category, id, properties) {
      var scrubbedDetail = (0, _scrubTelemetryData.scrubTelemetryData)(detail);
      var scrubbedCategory = (0, _scrubTelemetryData.scrubTelemetryData)(category);

      if (this._logger !== undefined) {
        this._logger.logFailure(signature, scrubbedDetail, scrubbedCategory, id, properties);
      }
    }
  }, {
    key: "setUserId",
    value: function setUserId(userId, pii, userIdType) {
      if (this._logger !== undefined) {
        var context = this._logger.getSemanticContext();

        context.setUserId(userId ? '<PII>' : '', pii, userIdType);
      }
    }
  }, {
    key: "flush",
    value: function flush() {
      _webjsSdk.AWTLogManager.flush(this._flushCallback);
    }
  }, {
    key: "flushAndTeardown",
    value: function flushAndTeardown() {
      _webjsSdk.AWTLogManager.flushAndTeardown();
    }
  }]);
  return AriaTelemetryProvider;
}();

exports.AriaTelemetryProvider = AriaTelemetryProvider;